// ユーザーがCookieに同意したかどうかを確認
const hasAcceptedCookie = localStorage.getItem('cookieAccepted');

// Cookieバナーを非表示にする関数
function hideCookieBanner() {
  const cookieBanner = document.getElementById('cookieBanner');
  cookieBanner.style.display = 'none';
}

// 「同意する」ボタンのクリックイベントを処理する関数
function handleAcceptClick() {
  // Cookieバナーを非表示にする
  hideCookieBanner();
  // ローカルストレージにユーザーがCookieに同意したことを示すフラグを設定する
  localStorage.setItem('cookieAccepted', 'true');
}

// Cookieバナーを表示する関数
function showCookieBanner() {
  const cookieBanner = document.getElementById('cookieBanner');
  cookieBanner.style.display = 'flex';
}

// 「同意する」ボタンにクリックイベントリスナーを追加する
document.addEventListener('DOMContentLoaded', function() {
  const acceptBtn = document.getElementById('acceptBtn');
  acceptBtn.addEventListener('click', handleAcceptClick);

  // ページの読み込みが完了したらCookieバナーを表示する
  if (hasAcceptedCookie !== 'true') {
    showCookieBanner();
  }
});
